/* eslint-disable semi */

/**
 * デコレータの基本設定値
 */
export default {
  Asynchronous: {},
  BindApi: {
    // NOTE
    // 複数の接続先がある場合は、ApiClientFactoryに登録してあるnameで指定してください。
    // factory: function(owner){},
    name: 'app',
    resetBefore: ['initialize']
  },
  BindAutofocus: {
    // NOTE
    // 個々のコンポーネントで指定すべき項目
    // refs: [] refで指定する必要がある場合は明示的に指定してください
    detect: true,
    resetBefore: []
  },
  BindDefault: {},
  BindErrors: { label: 'errors', resetBefore: ['initialize'] },
  BindForm: {
    ref: 'form',
    resetBefore: ['initialize'],
    bindedErrors: ['errors'],
    notify: false,
    notificator: function (reason) {
      this.$_app_notify.error(this.$t('common.notify.error.validation'));
    }
  },
  BindLoading: {
    // NOTE
    // 個々のコンポーネントで指定すべき項目
    // activeOn: [] ローディング対象の処理
    label: 'loading',
    resetBefore: ['initialize']
  },
  BindQuery: {
    // NOTE
    // 個々のコンポーネントで指定すべき項目
    // descriptors: {} クエリにバインドする型の定義
    label: 'query'
  },
  Loading: { label: 'loading' },
  ExposeElForm: {
    ref: 'form'
  },
  Synchronous: {}
};



// WEBPACK FOOTER //
// ./src/config/decorator.js